import { of } from 'rxjs';
var StubHomeService = /** @class */ (function () {
    function StubHomeService() {
    }
    StubHomeService.prototype.setHomeHubValues = function (values) {
        (function (t, w, d, polizaIframe) {
            polizaIframe['contentWindow'].poliza = { poliza: { stateObserver: true } };
        })(this, window, document, document.querySelector('#polizaIframe'));
    };
    StubHomeService.prototype.getSettingsWelcomeModal = function (userId) { };
    StubHomeService.prototype.getShowNewsModal = function () {
        return of({});
    };
    StubHomeService.prototype.sendMsg = function (w, values) { };
    StubHomeService.prototype.getUserSettings = function () {
        return of({});
    };
    StubHomeService.prototype.putNewsReadedForUserLogged = function () { };
    return StubHomeService;
}());
export { StubHomeService };
